<template>
	<div class="signle-footer">
		<div class="signle-info">{{ spRules.copyright }}</div>
	</div>
</template>

<script>
	import helper from '@/common/helper.js';
	export default {
		components: {
		},
		data() {
			return {
				spRules: {},
			};
		},
		methods: {},
		mounted() {
			this.spRules = this.$helper.get('rule');
		}
	}
</script>